/* Lockett Labs Events: Apply for a table.
   Five steps (show and table, business, stock, listing, check and send), a
   draft kept on this device, a logo upload, a live preview of the trader's
   listing, a running quote, and on success a way straight into the vendor
   dashboard. Validation mirrors the events desk's, field for field, and the
   desk's own answer (422 with field messages) takes them to the step that
   needs fixing. Everything goes on the page as text, never as HTML. */
(function () {
  'use strict';
  var EV = window.EV;
  var root = document.querySelector('[data-ev-apply]');
  if (!EV || !root) return;
  var el = EV.el;
  var API = EV.apiBase(root.getAttribute('data-api') || '');
  var DASH = root.getAttribute('data-dash-url') || '/pages/events?view=vendor-dashboard';
  var TRADERS = root.getAttribute('data-traders-url') || '/pages/events?view=event-traders';
  var DRAFT_KEY = 'll_ev_apply_draft';
  var TOKEN_KEY = 'll_ev_portal';
  var STEPS = ['Show and table', 'Your business', 'Your stock', 'Your listing', 'Check and send'];
  var box = root.querySelector('[data-eva-app]');
  var rail = root.querySelector('[data-eva-rail]');
  var sum = root.querySelector('[data-eva-sum]');
  var prog = root.querySelector('[data-eva-progress]');
  var events = [];
  var F = null;

  var DOMAIN_FIX = { 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.co.uk': 'gmail.com', 'gnail.com': 'gmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.co': 'hotmail.co.uk', 'hotmai.co.uk': 'hotmail.co.uk', 'outlok.com': 'outlook.com', 'yaho.com': 'yahoo.com', 'yahoo.co': 'yahoo.co.uk', 'icloud.co': 'icloud.com', 'btinternet.co': 'btinternet.com', 'live.co': 'live.co.uk' };
  var POSTCODE = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var HANDLE = /^@?[A-Za-z0-9._]{2,40}$/;

  /* ================================================================ helpers */
  function btn(label, cls, onclick, ic) {
    var b = el('button', { type: 'button', class: 'ev-btn ' + (cls || '') }, label);
    if (ic) b.append(EV.icon(ic, 'ev-arr'));
    if (onclick) b.addEventListener('click', onclick);
    return b;
  }
  function field(id, label, control, opts) {
    opts = opts || {};
    var wrap = el('div', { class: 'evf-field' + (opts.wide ? ' is-wide' : ''), 'data-f': id });
    var lab = el('label', { for: 'eva-' + id }, label);
    if (opts.optional) lab.append(el('span', { class: 'evf-opt', text: opts.optional === true ? 'optional' : opts.optional }));
    control.id = 'eva-' + id;
    wrap.append(lab, control);
    if (opts.help) wrap.append(el('small', { text: opts.help }));
    return wrap;
  }
  function input(name, value, attrs) { var i = el('input', Object.assign({ class: 'evf-input', name: name }, attrs || {})); i.value = value || ''; return i; }
  function textarea(name, value, attrs) { var t = el('textarea', Object.assign({ class: 'evf-textarea', name: name }, attrs || {})); t.value = value || ''; return t; }
  function setError(wrap, msg) {
    if (!wrap) return;
    var old = wrap.querySelector('.evf-err');
    if (old) old.remove();
    wrap.classList.toggle('has-error', !!msg);
    var ctl = wrap.querySelector('input, textarea, select');
    if (msg) { wrap.append(el('p', { class: 'evf-err', role: 'alert', text: msg })); if (ctl) ctl.setAttribute('aria-invalid', 'true'); }
    else if (ctl) ctl.removeAttribute('aria-invalid');
  }
  function showErrors(panel, errs) {
    panel.querySelectorAll('[data-f]').forEach(function (w) { setError(w, errs[w.getAttribute('data-f')] || ''); });
    var first = Object.keys(errs)[0];
    if (!first) return true;
    var w = panel.querySelector('[data-f="' + first + '"]');
    if (w) { w.scrollIntoView({ block: 'center', behavior: EV.reduce.matches ? 'auto' : 'smooth' }); var c = w.querySelector('input, textarea, button'); if (c) c.focus({ preventScroll: true }); }
    return false;
  }
  function niceDate(iso, opts) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', opts || { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
  }

  /* ================================================================ state and draft */
  function fresh() {
    var pre = new URLSearchParams(location.search).get('show');
    var open = openShows();
    var pick = open.filter(function (e) { return e.handle === pre; })[0] || (open.length === 1 ? open[0] : null);
    return {
      v: 2, step: 0, done: {}, startedAt: Date.now(), event: pick ? pick.handle : '', table: '', qty: 1, extras: [],
      f: { business_name: '', contact_name: '', email: '', phone: '', address_line1: '', address_line2: '', town: '', postcode: '', website: '', instagram: '', tiktok: '', facebook: '', bringing: '', needs: '', blurb: '' },
      categories: [], answers: {}, consent_listing: true, consent_marketing: false, consent_terms: false, logo: null, logoUrl: ''
    };
  }
  function saveDraft() {
    if (!F) return;
    try { localStorage.setItem(DRAFT_KEY, JSON.stringify(Object.assign({}, F, { logo: null, logoUrl: '', consent_terms: false, savedAt: Date.now() }))); } catch (e) { /* private mode */ }
    var s = root.querySelector('[data-evf-saved]');
    if (s) { s.textContent = 'Draft saved on this device'; s.classList.add('is-on'); }
  }
  var saveTimer = null;
  function saveSoon() { clearTimeout(saveTimer); saveTimer = setTimeout(saveDraft, 400); }
  function loadDraft() {
    try {
      var d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
      if (!d || !d.f || Date.now() - (d.savedAt || 0) > 30 * 86400000) return null;
      var base = fresh();
      d.f = Object.assign(base.f, d.f);
      if (d.event && !openShows().some(function (e) { return e.handle === d.event; })) d.event = '';
      var pre = new URLSearchParams(location.search).get('show');
      if (pre && openShows().some(function (e) { return e.handle === pre; }) && pre !== d.event) { d.event = pre; d.table = ''; d.extras = []; d.step = 0; }
      d.startedAt = Date.now();
      d.logo = null;
      d.logoUrl = '';
      d.step = Math.min(d.step || 0, 4);
      return d;
    } catch (e) { return null; }
  }
  function openShows() { return events.filter(function (e) { return e.applications && e.applications.accepting; }); }
  function currentEvent() { return events.filter(function (e) { return e.handle === F.event; })[0] || null; }

  /* ================================================================ the side: rail and quote */
  function quote() {
    var ev = currentEvent();
    if (!ev) return { lines: [], total: 0 };
    var t = (ev.tables || []).filter(function (x) { return x.id === F.table; })[0];
    var lines = [];
    if (t) lines.push([t.name + (F.qty > 1 ? ' × ' + F.qty : ''), t.price * F.qty]);
    (ev.extras || []).forEach(function (x) { if (F.extras.indexOf(x.id) > -1) lines.push([x.name, x.price * (x.per === 'table' ? F.qty : 1)]); });
    (ev.fees || []).forEach(function (f) { lines.push([f.name, f.price]); });
    return { lines: lines, total: lines.reduce(function (a, l) { return a + l[1]; }, 0), note: ev.priceNote, unpriced: t && !t.price };
  }
  function paintSide() {
    rail.querySelectorAll('li').forEach(function (li, i) {
      li.className = (F.step === i ? 'is-now' : '') + (F.done[i] && F.step !== i ? ' is-done' : '');
      li.setAttribute('aria-current', F.step === i ? 'step' : 'false');
    });
    var bar = root.querySelector('[data-eva-bar]');
    if (bar) bar.style.transform = 'scaleX(' + ((F.step + 1) / STEPS.length) + ')';
    var lab = root.querySelector('[data-eva-progress-label]');
    if (lab) lab.textContent = 'Step ' + (F.step + 1) + ' of ' + STEPS.length + ' · ' + STEPS[F.step];
    prog.hidden = false;
    sum.textContent = '';
    var ev = currentEvent();
    if (!ev) { sum.append(el('p', { class: 'eva-sum__empty', text: 'Pick a show and a table to see the price.' })); return; }
    var d = ev.startsAt ? new Date(ev.startsAt) : null;
    sum.append(el('div', { class: 'eva-sum__show' },
      el('span', { class: 'eva-sum__date' }, el('b', { text: d ? String(d.getDate()) : '?' }), el('span', { text: d ? d.toLocaleDateString('en-GB', { month: 'short' }) : '' })),
      el('span', null, el('b', { text: ev.title }), el('small', { text: [ev.venue, ev.town].filter(Boolean).join(', ') }))));
    var q = quote();
    if (q.lines.length) {
      var ul = el('ul', { class: 'eva-sum__lines' });
      q.lines.forEach(function (l) { ul.append(el('li', null, el('span', { text: l[0] }), el('span', { text: l[1] ? EV.money(l[1]) : 'Included' }))); });
      sum.append(ul, el('div', { class: 'eva-sum__total' }, el('span', { text: 'Estimated total' }), el('b', { text: q.unpriced ? 'On approval' : EV.money(q.total) })),
        el('small', { class: 'eva-sum__note', text: (q.note ? 'Prices ' + q.note + '. ' : '') + 'Nothing is charged now: your invoice follows if we offer you a table.' }));
    }
  }

  /* ================================================================ rendering */
  function render() {
    box.textContent = '';
    if (!openShows().length) { renderClosed(); return; }
    if (!F) {
      var d = loadDraft();
      F = d || fresh();
      if (d && (d.f.business_name || d.event)) box.append(resumeNote());
    }
    if (F.event && !openShows().some(function (e) { return e.handle === F.event; })) F.event = '';
    var panel = el('div', { class: 'eva-step' });
    box.append(panel);
    [stepShow, stepBusiness, stepStock, stepListing, stepReview][F.step](panel);
    paintSide();
  }
  function resumeNote() {
    var n = el('div', { class: 'eva-resume', role: 'status' }, EV.icon('refresh'), el('span', { text: 'We kept your draft from last time. Carry on where you left off.' }));
    var reset = el('button', { type: 'button', class: 'eva-resume__x', text: 'Start again' });
    reset.addEventListener('click', function () { try { localStorage.removeItem(DRAFT_KEY); } catch (e) { /* ignore */ } F = fresh(); render(); });
    n.append(reset);
    return n;
  }
  function renderClosed() {
    prog.hidden = true;
    var sched = events.filter(function (e) { return e.applications && e.applications.state === 'scheduled'; });
    var full = events.filter(function (e) { return e.applications && e.applications.state === 'full'; });
    var b = el('div', { class: 'evf-closed eva-closed' }, EV.icon('cal'),
      el('h2', { class: 'ev-display', text: sched.length ? 'Applications open soon' : 'Applications are closed for now' }));
    if (sched.length) {
      var ul = el('ul', { class: 'eva-closed__list' });
      sched.forEach(function (e) { ul.append(el('li', null, el('b', { text: e.title }), el('span', { text: 'Opens ' + niceDate(e.applications.opensAt, { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' }) }))); });
      b.append(ul);
    } else {
      b.append(el('p', { class: 'ev-muted', text: full.length ? 'We have all the applications we can take for the next show. New dates open here first.' : 'New dates open for applications here first.' }));
    }
    b.append(el('div', { class: 'ev-cta-row' }, el('a', { class: 'ev-btn ev-btn--primary', href: '/pages/events#community' }, 'Get told when they open'), el('a', { class: 'ev-btn', href: TRADERS }, 'How trading works')));
    box.append(b);
    sum.textContent = '';
  }
  function goStep(i) {
    F.step = i;
    saveDraft();
    render();
    var top = root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ev-header-h'), 10) || 76) - 12;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: EV.reduce.matches ? 'auto' : 'smooth' });
    var h = box.querySelector('.eva-step h2');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }
  function head(panel, n, title, text) {
    panel.append(el('div', { class: 'eva-step__head' }, el('span', { class: 'eva-step__n', text: '0' + (n + 1) }), el('div', null, el('h2', { class: 'ev-display', text: title }), text ? el('p', { text: text }) : null)));
  }
  function nav(panel, backFn, nextLabel, nextFn) {
    var row = el('div', { class: 'evf-nav eva-nav' });
    var left = el('div', { class: 'eva-nav__l' });
    if (backFn) { var b = btn('', '', backFn); b.prepend(EV.icon('back')); b.append('Back'); left.append(b); }
    row.append(left, btn(nextLabel, 'ev-btn--primary', nextFn, 'arrow'));
    panel.append(row);
  }
  rail.addEventListener('click', function (e) {
    var li = e.target.closest('li');
    if (!li || !F) return;
    var i = Array.prototype.indexOf.call(rail.children, li);
    if (i < F.step || F.done[i] || F.done[i - 1]) goStep(i);
  });

  /* ---------------------------------------------------------------- 1: show and table */
  function stepShow(panel) {
    head(panel, 0, 'Show and table', 'Which show, and what you need on the day.');
    var showWrap = el('div', { class: 'evf-field', 'data-f': 'event' }, el('span', { class: 'evf-label', text: 'Show' }));
    var choices = el('div', { class: 'eva-cards' });
    openShows().forEach(function (e) {
      var r = el('input', { type: 'radio', name: 'eva-event', value: e.handle });
      r.checked = F.event === e.handle;
      r.addEventListener('change', function () { F.event = e.handle; F.table = ''; F.extras = []; F.categories = F.categories.filter(function (c) { return (e.categories || []).indexOf(c) > -1; }); saveSoon(); render(); });
      var a = e.applications;
      var flag = a.state === 'waitlist' ? 'Reserve list only' : a.remaining != null ? a.remaining + (a.remaining === 1 ? ' place left' : ' places left') : a.closesAt ? 'Closes ' + niceDate(a.closesAt, { day: 'numeric', month: 'short' }) : '';
      var d = e.startsAt ? new Date(e.startsAt) : null;
      choices.append(el('label', { class: 'eva-card' }, r,
        el('span', { class: 'eva-card__date' }, el('b', { text: d ? String(d.getDate()) : '?' }), el('span', { text: d ? d.toLocaleDateString('en-GB', { month: 'short' }) : '' })),
        el('span', { class: 'eva-card__tx' }, el('b', { text: e.title }), el('span', { text: [e.dateLabel, [e.venue, e.town].filter(Boolean).join(', ')].filter(Boolean).join(' · ') }),
          flag ? el('em', { text: flag }) : null, e.perks && e.perks.whatsapp ? el('span', { class: 'eva-card__perk' }, EV.icon('whatsapp'), "Traders' WhatsApp group") : null),
        el('span', { class: 'eva-card__tick' }, EV.icon('check'))));
    });
    showWrap.append(choices);
    panel.append(showWrap);

    var ev = currentEvent();
    if (ev) {
      if (ev.applications.state === 'waitlist') panel.append(el('p', { class: 'evp-alert' }, el('b', { text: 'Every table is taken. ' }), 'Applications for this show go on the reserve list, and we contact you if a table comes free.'));
      if (ev.tables.length === 1 && !F.table) F.table = ev.tables[0].id;
      var tWrap = el('div', { class: 'evf-field', 'data-f': 'table_type' }, el('span', { class: 'evf-label', text: 'Table' }));
      var tc = el('div', { class: 'eva-tables' });
      ev.tables.forEach(function (t) {
        var r = el('input', { type: 'radio', name: 'eva-table', value: t.id });
        r.checked = F.table === t.id;
        r.addEventListener('change', function () { F.table = t.id; F.qty = Math.min(F.qty, t.maxQty || 1); saveSoon(); render(); });
        tc.append(el('label', { class: 'eva-table' }, r,
          el('span', { class: 'eva-table__top' }, el('b', { text: t.name }), t.size ? el('small', { text: t.size }) : null),
          el('span', { class: 'eva-table__p', text: t.price > 0 ? EV.money(t.price) : 'On approval' }),
          t.description ? el('span', { class: 'eva-table__d', text: t.description }) : null,
          el('span', { class: 'eva-card__tick' }, EV.icon('check'))));
      });
      tWrap.append(tc);
      panel.append(tWrap);

      var t = ev.tables.filter(function (x) { return x.id === F.table; })[0];
      if (t && (t.maxQty || 1) > 1) {
        var out = el('output', { text: String(F.qty), 'aria-live': 'polite' });
        var step = function (dd) { F.qty = Math.max(1, Math.min(t.maxQty, F.qty + dd)); out.textContent = String(F.qty); saveSoon(); paintSide(); };
        panel.append(el('div', { class: 'evf-field', 'data-f': 'table_qty' }, el('span', { class: 'evf-label', text: 'How many tables' }),
          el('div', { class: 'evf-stepper' }, el('button', { type: 'button', 'aria-label': 'One fewer', text: '−', onclick: function () { step(-1); } }), out, el('button', { type: 'button', 'aria-label': 'One more', text: '+', onclick: function () { step(1); } })),
          el('small', { text: 'Up to ' + t.maxQty + ' per trader.' })));
      }
      if ((ev.extras || []).length) {
        var xw = el('div', { class: 'evf-field' }, el('span', { class: 'evf-label' }, 'Extras', el('span', { class: 'evf-opt', text: 'optional' })));
        var xc = el('div', { class: 'eva-extras' });
        ev.extras.forEach(function (x) {
          var c = el('input', { type: 'checkbox', value: x.id });
          c.checked = F.extras.indexOf(x.id) > -1;
          c.addEventListener('change', function () {
            F.extras = F.extras.filter(function (id) { return id !== x.id; });
            if (c.checked) F.extras.push(x.id);
            saveSoon();
            paintSide();
          });
          xc.append(el('label', { class: 'eva-extra' }, c, el('span', { class: 'eva-extra__box' }, EV.icon('check')), el('span', null, el('b', { text: x.name }), x.description ? el('small', { text: x.description }) : null), el('em', { text: x.priceLabel })));
        });
        xw.append(xc);
        panel.append(xw);
      }
      if (ev.info && ev.info.included) panel.append(el('p', { class: 'ev-note' }, el('b', { text: 'Every table includes: ' }), ev.info.included));
    }
    nav(panel, null, 'Next: your business', function () {
      var errs = {};
      if (!F.event) errs.event = 'Choose a show.';
      if (panel.querySelector('[data-f="table_type"]') && !F.table) errs.table_type = 'Choose a table.';
      if (!showErrors(panel, errs)) return;
      F.done[0] = true;
      goStep(1);
    });
  }

  /* ---------------------------------------------------------------- 2: business */
  function bind(name, node, panel) {
    node.addEventListener('input', function () { F.f[name] = node.value; saveSoon(); setError(node.closest('.evf-field'), ''); if (panel && panel.__onInput) panel.__onInput(name); });
    return node;
  }
  function stepBusiness(panel) {
    head(panel, 1, 'Your business', 'Who you are and how we reach you. Your invoice goes to this name and address.');
    var g = el('div', { class: 'evf-grid' });
    g.append(
      field('business_name', 'Trading name', bind('business_name', input('business_name', F.f.business_name, { autocomplete: 'organization', maxlength: 120 })), { help: 'As it should appear on the show page and your invoice.' }),
      field('contact_name', 'Your name', bind('contact_name', input('contact_name', F.f.contact_name, { autocomplete: 'name', maxlength: 120 }))),
      field('email', 'Email', bind('email', input('email', F.f.email, { type: 'email', autocomplete: 'email', inputmode: 'email', maxlength: 191 })), { help: 'Your dashboard link and every update come here.' }),
      field('phone', 'Mobile number', bind('phone', input('phone', F.f.phone, { type: 'tel', autocomplete: 'tel', inputmode: 'tel', maxlength: 40 })), { help: 'For the day itself.' }),
      field('address_line1', 'Address', bind('address_line1', input('address_line1', F.f.address_line1, { autocomplete: 'address-line1', maxlength: 120 })), { wide: true }),
      field('address_line2', 'Address line 2', bind('address_line2', input('address_line2', F.f.address_line2, { autocomplete: 'address-line2', maxlength: 120 })), { optional: true, wide: true }),
      field('town', 'Town', bind('town', input('town', F.f.town, { autocomplete: 'address-level2', maxlength: 80 }))),
      field('postcode', 'Postcode', bind('postcode', input('postcode', F.f.postcode, { autocomplete: 'postal-code', maxlength: 10, style: 'text-transform:uppercase' })))
    );
    panel.append(g);
    var em = panel.querySelector('#eva-email');
    var hint = el('p', { class: 'evf-hint-fix', hidden: true });
    em.closest('.evf-field').append(hint);
    em.addEventListener('blur', function () {
      var m = em.value.trim().toLowerCase().match(/@(.+)$/);
      var fix = m && DOMAIN_FIX[m[1]];
      hint.hidden = !fix;
      if (fix) {
        hint.textContent = 'Did you mean ';
        var use = el('button', { type: 'button', text: em.value.trim().replace(/@.+$/, '@' + fix) });
        use.addEventListener('click', function () { em.value = use.textContent; F.f.email = em.value; hint.hidden = true; saveSoon(); });
        hint.append(use, '?');
      }
    });
    nav(panel, function () { goStep(0); }, 'Next: your stock', function () {
      var errs = {};
      if (!F.f.business_name.trim()) errs.business_name = 'Tell us the name you trade under.';
      if (!F.f.contact_name.trim()) errs.contact_name = 'Who should we talk to?';
      if (!EMAIL.test(F.f.email.trim())) errs.email = 'That email does not look right.';
      if (F.f.phone.replace(/\D/g, '').length < 9) errs.phone = 'A phone number we can reach you on during the show.';
      if (!F.f.address_line1.trim()) errs.address_line1 = 'Invoices go to this address, so we need the first line.';
      if (!F.f.town.trim()) errs.town = 'Which town?';
      if (!POSTCODE.test(F.f.postcode.trim())) errs.postcode = 'That does not look like a UK postcode.';
      if (!showErrors(panel, errs)) return;
      F.done[1] = true;
      goStep(2);
    });
  }

  /* ---------------------------------------------------------------- 3: stock */
  function stepStock(panel) {
    var ev = currentEvent();
    head(panel, 2, 'Your stock', 'What will be on your table. It helps us put the right mix of traders in the room.');
    var cWrap = el('div', { class: 'evf-field', 'data-f': 'categories' }, el('span', { class: 'evf-label', text: 'You will be selling' }));
    var chips = el('div', { class: 'evf-chips eva-chips' });
    (ev ? ev.categories : []).forEach(function (c) {
      var cb = el('input', { type: 'checkbox', value: c });
      cb.checked = F.categories.indexOf(c) > -1;
      cb.addEventListener('change', function () {
        F.categories = F.categories.filter(function (x) { return x !== c; });
        if (cb.checked) F.categories.push(c);
        setError(cWrap, '');
        saveSoon();
      });
      chips.append(el('label', {}, cb, el('span', { text: c })));
    });
    cWrap.append(chips);
    panel.append(cWrap);
    var br = textarea('bringing', F.f.bringing, { maxlength: 1500, placeholder: 'For example: vintage Pokémon singles, graded slabs, a box of sealed One Piece, binders of trades.' });
    var count = el('small', { class: 'eva-count' });
    var paint = function () { count.textContent = br.value.length + ' / 1500'; };
    br.addEventListener('input', function () { F.f.bringing = br.value; paint(); saveSoon(); setError(br.closest('.evf-field'), ''); });
    paint();
    var bw = field('bringing', 'Tell us about your stock', br, { help: 'A few sentences is plenty. This is for us, not the public.' });
    bw.append(count);
    panel.append(bw);
    var qs = ev ? ev.questions || [] : [];
    qs.forEach(function (q) {
      var t = textarea('answers[' + q.id + ']', F.answers[q.id] || '', { maxlength: 800, style: 'min-height:80px' });
      t.addEventListener('input', function () { F.answers[q.id] = t.value; saveSoon(); setError(t.closest('.evf-field'), ''); });
      panel.append(field('answers.' + q.id, q.label, t, { optional: !q.required }));
    });
    var nd = textarea('needs', F.f.needs, { maxlength: 800, style: 'min-height:90px', placeholder: 'Step-free access, a power socket nearby, who you would like to be next to...' });
    nd.addEventListener('input', function () { F.f.needs = nd.value; saveSoon(); });
    panel.append(field('needs', 'Anything we should know', nd, { optional: true }));
    nav(panel, function () { goStep(1); }, 'Next: your listing', function () {
      var errs = {};
      if (!F.categories.length) errs.categories = 'Pick at least one thing you will be selling.';
      if (F.f.bringing.trim().length < 20) errs.bringing = 'A sentence or two about your stock helps us plan the room.';
      qs.forEach(function (q) { if (q.required && !(F.answers[q.id] || '').trim()) errs['answers.' + q.id] = 'Please answer this one.'; });
      if (!showErrors(panel, errs)) return;
      F.done[2] = true;
      goStep(3);
    });
  }

  /* ---------------------------------------------------------------- 4: listing */
  function stepListing(panel) {
    head(panel, 3, 'Your listing', 'How visitors find you on the show page and in Who\'s trading, once your table is confirmed.');
    var grid = el('div', { class: 'eva-listing' });
    var form = el('div', { class: 'eva-listing__form' });
    var preview = el('div', { class: 'eva-listing__prev', 'aria-live': 'polite' });
    grid.append(form, preview);
    panel.append(grid);

    // logo
    var logoBox = el('div', { class: 'evf-logo__box eva-logo', tabindex: '0', role: 'button', 'aria-label': 'Add your logo' });
    var file = el('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/gif', 'aria-label': 'Logo file', class: 'ev-sr' });
    var showLogo = function () {
      logoBox.textContent = '';
      if (F.logoUrl) logoBox.append(el('img', { src: F.logoUrl, alt: 'Your logo' }), el('span', { class: 'eva-logo__swap', text: 'Change' }));
      else logoBox.append(EV.icon('img'), el('b', { text: 'Add your logo' }), el('span', { text: 'Drop it here or tap to choose' }));
    };
    var takeFile = function (fl) {
      var wrap = form.querySelector('[data-f="logo"]');
      if (!fl) return;
      if (!/^image\/(png|jpeg|webp|gif)$/.test(fl.type)) { setError(wrap, 'Use a PNG, JPG, WebP or GIF.'); return; }
      if (fl.size > 6 * 1024 * 1024) { setError(wrap, 'Logos must be under 6 MB.'); return; }
      setError(wrap, '');
      if (F.logoUrl) URL.revokeObjectURL(F.logoUrl);
      F.logo = fl;
      F.logoUrl = URL.createObjectURL(fl);
      showLogo();
      paintPreview();
    };
    showLogo();
    logoBox.addEventListener('click', function () { file.click(); });
    logoBox.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); file.click(); } });
    logoBox.addEventListener('dragover', function (e) { e.preventDefault(); logoBox.classList.add('is-drag'); });
    logoBox.addEventListener('dragleave', function () { logoBox.classList.remove('is-drag'); });
    logoBox.addEventListener('drop', function (e) { e.preventDefault(); logoBox.classList.remove('is-drag'); takeFile(e.dataTransfer.files[0]); });
    file.addEventListener('change', function () { takeFile(file.files[0]); });
    form.append(el('div', { class: 'evf-field', 'data-f': 'logo' }, el('span', { class: 'evf-label' }, 'Logo', el('span', { class: 'evf-opt', text: 'recommended' })),
      el('div', { class: 'evf-logo' }, logoBox, el('p', { class: 'ev-muted ev-small', text: 'Square works best, at least 400 pixels. We redraw it as a clean image, so anything hidden in the file is left behind. It also goes on your promo posters.' })), file));

    // the line
    var bl = textarea('blurb', F.f.blurb, { maxlength: 280, style: 'min-height:84px', placeholder: 'Vintage WOTC singles and a £5 binder for younger collectors. Come and say hi.' });
    var bc = el('small', { class: 'eva-count' });
    var paintBc = function () { bc.textContent = bl.value.length + ' / 280'; };
    bl.addEventListener('input', function () { F.f.blurb = bl.value.replace(/\s+/g, ' '); paintBc(); saveSoon(); paintPreview(); });
    paintBc();
    var blw = field('blurb', 'A line about you', bl, { optional: 'for the public list', help: 'One or two sentences visitors will read on your profile.' });
    blw.append(bc);
    form.append(blw);

    // links
    var links = el('div', { class: 'evf-grid' });
    links.append(
      field('website', 'Website', bind('website', input('website', F.f.website, { inputmode: 'url', placeholder: 'yourshop.co.uk', maxlength: 300 }), panel), { optional: true }),
      field('instagram', 'Instagram', bind('instagram', input('instagram', F.f.instagram, { placeholder: '@yourshop', maxlength: 200 }), panel), { optional: true }),
      field('tiktok', 'TikTok', bind('tiktok', input('tiktok', F.f.tiktok, { placeholder: '@yourshop', maxlength: 200 }), panel), { optional: true }),
      field('facebook', 'Facebook', bind('facebook', input('facebook', F.f.facebook, { placeholder: 'facebook.com/yourshop', maxlength: 200 }), panel), { optional: true })
    );
    form.append(links);

    var cl = el('input', { type: 'checkbox' });
    cl.checked = !!F.consent_listing;
    cl.addEventListener('change', function () { F.consent_listing = cl.checked; saveSoon(); paintPreview(); });
    form.append(el('label', { class: 'evf-tick eva-switch' }, cl, el('span', null, el('b', { text: 'List my business publicly' }), el('small', { text: 'On the show page and in Who\'s trading, once my table is confirmed. Change it any time from your dashboard.' }))));

    panel.__onInput = function () { paintPreview(); };
    function paintPreview() {
      preview.textContent = '';
      var ev = currentEvent();
      var v = EV.vendorFrom({ name: F.f.business_name || 'Your trading name', logo: '', categories: F.categories, blurb: F.f.blurb.trim() });
      var card = EV.vendorCard(v, function () {});
      card.tabIndex = -1;
      card.setAttribute('aria-hidden', 'true');
      var logo = card.querySelector('.evx-vlogo');
      if (F.logoUrl && logo) { logo.textContent = ''; logo.append(el('img', { src: F.logoUrl, alt: '' })); }
      preview.append(el('span', { class: 'eva-listing__k', text: 'How it will look' }), card);
      if (v.blurb) preview.append(el('p', { class: 'eva-listing__blurb', text: v.blurb }));
      var nets = [['website', 'globe'], ['instagram', 'instagram'], ['tiktok', 'tiktok'], ['facebook', 'facebook']].filter(function (n) { return F.f[n[0]].trim(); });
      if (nets.length) {
        var row = el('div', { class: 'eva-listing__nets' });
        nets.forEach(function (n) { row.append(el('span', null, EV.icon(n[1]))); });
        preview.append(row);
      }
      if (!F.consent_listing) preview.append(el('p', { class: 'eva-listing__off' }, EV.icon('lock'), 'Not listed publicly. Only we see this.'));
      if (ev) preview.append(el('small', { class: 'eva-listing__where', text: 'On ' + ev.title + "'s page, with the other traders." }));
    }
    paintPreview();

    nav(panel, function () { goStep(2); }, 'Next: check and send', function () {
      var errs = {};
      if (F.f.website.trim() && !/^(https?:\/\/)?[^\s.\/]+(\.[^\s.\/]+)+(\/\S*)?$/i.test(F.f.website.trim())) errs.website = 'That link does not look right. Try the full address.';
      [['instagram', 'instagram.com'], ['tiktok', 'tiktok.com'], ['facebook', 'facebook.com']].forEach(function (n) {
        var v = F.f[n[0]].trim();
        if (v && !HANDLE.test(v) && v.toLowerCase().indexOf(n[1]) === -1) errs[n[0]] = 'Paste the link to your profile or just the @handle.';
      });
      if (!showErrors(panel, errs)) return;
      F.done[3] = true;
      goStep(4);
    });
  }

  /* ---------------------------------------------------------------- 5: check and send */
  function stepReview(panel) {
    var ev = currentEvent();
    var t = ev ? ev.tables.filter(function (x) { return x.id === F.table; })[0] : null;
    head(panel, 4, 'Check and send', 'One last look. You can change anything here, and again from your dashboard until we decide.');
    var dl = el('dl', { class: 'evf-review eva-review' });
    var row = function (k, v, step) { dl.append(el('div', {}, el('dt', { text: k }), el('dd', { text: v || 'Not given' }), el('button', { type: 'button', text: 'Change', onclick: function () { goStep(step); } }))); };
    row('Show', ev ? ev.title + ', ' + ev.dateLabel : '', 0);
    row('Table', t ? t.name + (F.qty > 1 ? ' × ' + F.qty : '') : '', 0);
    if (F.extras.length && ev) row('Extras', ev.extras.filter(function (x) { return F.extras.indexOf(x.id) > -1; }).map(function (x) { return x.name; }).join(', '), 0);
    row('Business', F.f.business_name, 1);
    row('Contact', [F.f.contact_name, F.f.email, F.f.phone].join('\n'), 1);
    row('Address', [F.f.address_line1, F.f.address_line2, F.f.town, F.f.postcode.toUpperCase()].filter(Boolean).join(', '), 1);
    row('Selling', F.categories.join(', '), 2);
    row('Your stock', F.f.bringing, 2);
    row('Logo', F.logo ? F.logo.name : 'None added', 3);
    row('Your line', F.f.blurb.trim(), 3);
    row('Listed publicly', F.consent_listing ? 'Yes, once confirmed' : 'No', 3);
    panel.append(dl);

    var q = quote();
    if (q.lines.length) {
      var qb = el('div', { class: 'evf-quote' });
      q.lines.forEach(function (l) { qb.append(el('div', {}, el('span', { text: l[0] }), el('span', { text: l[1] ? EV.money(l[1]) : 'Included' }))); });
      qb.append(el('div', { class: 'is-total' }, el('span', { text: 'Estimated total' }), el('span', { text: q.unpriced ? 'On approval' : EV.money(q.total) })));
      qb.append(el('small', { class: 'ev-muted', text: (q.note ? 'Prices ' + q.note + '. ' : '') + 'Nothing is charged now. If we offer you a table, your invoice follows by email.' }));
      panel.append(qb);
    }

    var tick = function (name, label, checked, onchange) {
      var c = el('input', { type: 'checkbox', name: name });
      c.checked = checked;
      c.addEventListener('change', function () { onchange(c.checked); saveSoon(); setError(c.closest('[data-f]'), ''); });
      return el('label', { class: 'evf-tick' }, c, el('span', {}, label));
    };
    var termsLink = el('button', { type: 'button', class: 'eva-linkbtn', text: 'trader terms' });
    termsLink.addEventListener('click', openTerms);
    panel.append(el('div', { class: 'evf-consent' },
      el('div', { 'data-f': 'consent_terms' }, tick('consent_terms', el('span', {}, 'I have read and agree to the ', termsLink, '.'), F.consent_terms, function (v) { F.consent_terms = v; })),
      tick('consent_marketing', 'Email me when tables open for future shows.', F.consent_marketing, function (v) { F.consent_marketing = v; })));
    var priv = root.getAttribute('data-privacy');
    panel.append(el('p', { class: 'ev-muted ev-small' }, 'We use your details to manage your application and booking. ', priv ? el('a', { href: priv, text: 'Privacy policy' }) : null));
    // The field a person never sees. Bots fill it in.
    panel.append(el('div', { class: 'evf-hp', 'aria-hidden': 'true' }, el('label', {}, 'Company website', el('input', { type: 'text', name: 'company_website', tabindex: '-1', autocomplete: 'off', 'data-evf-hp': true }))));
    var status = el('div', { 'aria-live': 'assertive' });
    panel.append(status);
    var send = btn('Send application', 'ev-btn--primary eva-send', null, 'arrow');
    var row2 = el('div', { class: 'evf-nav eva-nav' });
    var back = btn('', '', function () { goStep(3); });
    back.prepend(EV.icon('back'));
    back.append('Back');
    row2.append(back, send);
    panel.append(row2);
    send.addEventListener('click', function () {
      if (!F.consent_terms) { showErrors(panel, { consent_terms: 'Please read and accept the trader terms.' }); return; }
      submit(send, status, panel);
    });
  }

  /* The terms live on the Trade with us page; read them from there. */
  var termsDlg = root.querySelector('[data-eva-terms]');
  var termsLoaded = false;
  function openTerms() {
    if (!termsDlg || typeof termsDlg.showModal !== 'function') { window.open(TRADERS + '#terms', '_blank', 'noopener'); return; }
    termsDlg.showModal();
    document.documentElement.classList.add('ev-locked');
    if (termsLoaded) return;
    var body = termsDlg.querySelector('[data-eva-terms-body]');
    fetch(TRADERS, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('[data-evt-terms-body]');
      if (!src) throw new Error('no terms');
      body.textContent = '';
      // Only paragraphs, bold, emphasis and links survive: the terms are ours,
      // but nothing else from the fetched page is ever put in this one.
      src.querySelectorAll('p, li').forEach(function (p) {
        var out = el('p');
        p.childNodes.forEach(function (n) {
          if (n.nodeType === 3) out.append(n.textContent);
          else if (/^(STRONG|B)$/.test(n.nodeName)) out.append(el('b', { text: n.textContent }));
          else if (/^(EM|I)$/.test(n.nodeName)) out.append(el('em', { text: n.textContent }));
          else if (n.nodeName === 'A' && /^(https?:|\/)/.test(n.getAttribute('href') || '')) out.append(el('a', { href: n.getAttribute('href'), text: n.textContent, target: '_blank', rel: 'noopener' }));
          else out.append(n.textContent || '');
        });
        body.append(out);
      });
      var v = src.getAttribute('data-version');
      if (v) body.append(el('p', { class: 'ev-muted ev-small', text: 'Version ' + v }));
      termsLoaded = true;
    }).catch(function () {
      body.textContent = '';
      body.append(el('p', null, 'Read them on the ', el('a', { href: TRADERS + '#terms', target: '_blank', rel: 'noopener', text: 'Trade with us page' }), '.'));
    });
  }
  if (termsDlg) {
    termsDlg.addEventListener('close', function () { document.documentElement.classList.remove('ev-locked'); });
    termsDlg.addEventListener('click', function (e) { if (e.target === termsDlg || e.target.closest('[data-eva-terms-close]')) termsDlg.close(); });
    var agree = termsDlg.querySelector('[data-eva-terms-agree]');
    if (agree) agree.addEventListener('click', function () {
      F.consent_terms = true;
      var c = box.querySelector('input[name="consent_terms"]');
      if (c) { c.checked = true; setError(c.closest('[data-f]'), ''); }
      termsDlg.close();
    });
  }

  /* ---------------------------------------------------------------- send */
  function stepOf(k) {
    if (/^(event|table_type|table_qty)$/.test(k)) return 0;
    if (/^(categories|bringing|needs|answers\.)/.test(k)) return 2;
    if (/^(website|instagram|tiktok|facebook|blurb|logo)$/.test(k)) return 3;
    if (k === 'consent_terms') return 4;
    return 1;
  }
  function submit(button, status, panel) {
    var fd = new FormData();
    fd.append('event', F.event);
    fd.append('table_type', F.table);
    fd.append('table_qty', String(F.qty));
    F.extras.forEach(function (x) { fd.append('extras[]', x); });
    Object.keys(F.f).forEach(function (k) { fd.append(k, (F.f[k] || '').trim()); });
    F.categories.forEach(function (c) { fd.append('categories[]', c); });
    Object.keys(F.answers).forEach(function (k) { fd.append('answers[' + k + ']', F.answers[k] || ''); });
    if (F.consent_terms) fd.append('consent_terms', '1');
    if (F.consent_listing) fd.append('consent_listing', '1');
    if (F.consent_marketing) fd.append('consent_marketing', '1');
    var hp = panel.querySelector('[data-evf-hp]');
    fd.append('company_website', hp ? hp.value : '');
    fd.append('elapsed', String(Date.now() - (F.startedAt || Date.now())));
    if (F.logo) fd.append('logo', F.logo, F.logo.name);
    button.classList.add('is-busy');
    button.disabled = true;
    status.textContent = '';
    EV.api(API, 'public.php?action=apply', { method: 'POST', body: fd }).then(function (res) {
      try { localStorage.removeItem(DRAFT_KEY); } catch (e) { /* ignore */ }
      var token = res.portal && res.portal.indexOf('#portal=') > -1 ? res.portal.split('#portal=')[1] : '';
      if (token) { try { sessionStorage.setItem(TOKEN_KEY, token); } catch (e) { /* ignore */ } }
      done(res, token);
    }).catch(function (err) {
      button.classList.remove('is-busy');
      button.disabled = false;
      if (err.status === 422 && err.fields && Object.keys(err.fields).length) {
        F.step = Math.min.apply(null, Object.keys(err.fields).map(stepOf));
        render();
        showErrors(box.querySelector('.eva-step'), err.fields);
        return;
      }
      status.append(el('p', { class: 'ev-form-bad', text: err.message }));
      if (err.code === 'duplicate') status.append(el('p', { class: 'ev-muted' }, 'Check your inbox for the link, or ', el('a', { href: DASH, text: 'ask for it again' }), '.'));
      if (err.code === 'closed') { load().then(function () { setTimeout(render, 3500); }).catch(function () {}); }
    });
  }

  function done(res, token) {
    var ev = currentEvent();
    box.textContent = '';
    prog.hidden = true;
    rail.querySelectorAll('li').forEach(function (li) { li.className = 'is-done'; });
    var wait = res.status === 'waitlisted';
    var burst = el('div', { class: 'eva-burst', 'aria-hidden': 'true' });
    for (var i = 0; i < 14; i++) burst.append(el('i', { style: '--a:' + (i * 360 / 14) + 'deg;--d:' + (i % 3) }));
    burst.append(el('span', { class: 'eva-burst__nut' }, EV.icon('nut')));
    var link = DASH + (token ? '#portal=' + token : '');
    var b = el('div', { class: 'eva-done' }, burst,
      el('span', { class: 'ev-kicker is-gold', text: wait ? 'On the reserve list' : 'Application sent' }),
      el('h2', { class: 'ev-display', text: wait ? 'You are on the reserve list' : 'Thank you. We have it.' }),
      el('div', { class: 'eva-done__ref' }, el('small', { text: 'Your reference' }), el('b', { text: res.ref })),
      el('p', { text: 'We have emailed ' + (res.email || 'you') + ' a private link to your vendor dashboard' + (ev ? ' for ' + ev.title : '') + '. It is where you follow your application, message us, pay, and later get your promo kit and the traders\' WhatsApp group.' }),
      el('div', { class: 'ev-cta-row' }, el('a', { class: 'ev-btn ev-btn--primary', href: link }, 'Open your dashboard', EV.icon('arrow', 'ev-arr')), el('a', { class: 'ev-btn', href: '/pages/events' }, 'Back to the shows')),
      el('ol', { class: 'eva-done__next' },
        el('li', null, el('b', { text: 'Now' }), el('span', { text: 'We read every application ourselves.' })),
        el('li', null, el('b', { text: 'Within a week' }), el('span', { text: wait ? 'If a table comes free, you hear first.' : 'We email you a decision, or a question.' })),
        el('li', null, el('b', { text: 'Offered a table' }), el('span', { text: 'Your invoice follows. Paid means confirmed.' }))));
    box.append(b);
    root.scrollIntoView({ block: 'start', behavior: EV.reduce.matches ? 'auto' : 'smooth' });
    var h = b.querySelector('h2');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    sum.textContent = '';
    F = null;
  }

  /* ================================================================ go */
  function load() { return EV.api(API, 'public.php?action=events').then(function (d) { events = d.events || []; return events; }); }
  if (!API) return;
  load().then(render).catch(function () {
    box.textContent = '';
    var mail = root.getAttribute('data-contact') || '';
    box.append(el('div', { class: 'evf-closed' }, el('h2', { class: 'ev-display', text: 'The form is not answering' }),
      el('p', { class: 'ev-muted' }, 'We could not reach the events desk just now. Please try again in a few minutes', mail ? ', or email ' : '.', mail ? el('a', { href: 'mailto:' + mail, text: mail }) : null),
      btn('Try again', '', function () { location.reload(); })));
  });
})();
